/**
 * MetaTagTester - Development component to test meta tag functionality
 * This component should only be used in development for testing social sharing
 */

import React, { useState } from 'react';
import metaTagManager from '../utils/MetaTagManager';

const MetaTagTester = () => {
  const [testChannel, setTestChannel] = useState(null);

  // Sample channel data for testing
  const sampleChannels = [
    {
      _id: '642af72a8c31440e9cb11627',
      title: 'Doggo And The Shotguns Choir',
      description: 'A freak show\'s Dogman escapes to freedom but soon finds the outside world might be an even weirder place. A lone cowboy fights his inner demons while searching for his lost love.',
      programming_type: 'Movie',
      year: '2018',
      rating: 'TV-MA',
      genres: ['Drama', 'Western'],
      poster: 'https://chillfreedspmedia.cachefly.net/images/6421c8232e41ca3fde0c8f51',
      spotlight_poster: 'https://chillfreedspmedia.cachefly.net/images/6421c8272e41ca3fde0c8f52',
      slug: 'doggo-and-the-shotguns-choir'
    },
    {
      _id: '649b4605454b260ec209f614',
      title: 'Max and Me',
      description: 'A heartwarming story about friendship and adventure.',
      programming_type: 'Series',
      year: '2023',
      rating: 'TV-PG',
      genres: ['Family', 'Adventure'],
      poster: 'https://chillfreedspmedia.cachefly.net/images/sample-poster.jpg',
      slug: 'max-and-me'
    }
  ];

  const handleTestMetaTags = (channel) => {
    setTestChannel(channel);
    metaTagManager.updateChannelMetaTags(channel);
    
    // Debug the meta tags
    setTimeout(() => {
      metaTagManager.debugSocialTags();
    }, 100);
  };

  const handleRestoreMetaTags = () => {
    setTestChannel(null);
    metaTagManager.restoreOriginalMetaTags();
    console.log('🏷️ Meta tags restored to original state');
  };

  if (process.env.NODE_ENV !== 'development') {
    return null; // Don't render in production
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '15px',
      borderRadius: '8px',
      zIndex: 9999,
      fontSize: '12px',
      maxWidth: '300px'
    }}>
      <h4 style={{ margin: '0 0 10px 0', color: '#4FD1C7' }}>🏷️ Meta Tag Tester</h4>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>Current:</strong> {testChannel ? testChannel.title : 'Default ChillFree'}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        {sampleChannels.map((channel) => (
          <button
            key={channel._id}
            onClick={() => handleTestMetaTags(channel)}
            style={{
              background: testChannel?._id === channel._id ? '#4FD1C7' : '#333',
              color: 'white',
              border: 'none',
              padding: '5px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '11px'
            }}
          >
            Test: {channel.title}
          </button>
        ))}
        
        <button
          onClick={handleRestoreMetaTags}
          style={{
            background: '#666',
            color: 'white',
            border: 'none',
            padding: '5px 8px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            marginTop: '5px'
          }}
        >
          Restore Defaults
        </button>
      </div>

      <div style={{ marginTop: '10px', fontSize: '10px', color: '#ccc' }}>
        Check browser console for debug info and social sharing URLs
      </div>
    </div>
  );
};

export default MetaTagTester;
